var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcTelegramLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8432 19.8176L12.3579 26.5184C13.0522 26.5184 13.3528 26.2256 13.7134 25.874L16.9683 22.82L23.7126 27.6692C24.9496 28.346 25.821 27.9896 26.1547 26.552L30.5817 6.18568L30.5829 6.18448C30.9753 4.38928 29.9217 3.68729 28.7165 4.12769L2.69481 13.9088C0.918882 14.5856 0.945772 15.5576 2.39292 15.998L9.04563 18.0296L24.4986 8.53646C25.2258 8.06367 25.887 8.32526 25.3431 8.79806L12.8432 19.8176Z",
    fill: "#0D1A16"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelegramLight);
export default __webpack_public_path__ + "static/media/ic_telegramLight.3976f0d0cbb418178ff5e5299d4ee75e.svg";
export { ForwardRef as ReactComponent };